<template>
	<div class="home-container">
		<HeaderLayout />
		<MainNav />


		<div class="main-section container">
			<h2
				class="view-header"
				v-if="$route.name && $route.name !== 'dashboard'"
				key="0"
			>
				{{ $route.meta.header }}
			</h2>

			<transition-group
				name="transition-anim"
				tag="section"
				class="view-container"
			>
				<router-view key="1" class="router-view "/>
			</transition-group>
		</div>
	</div>
</template>
<script>
import MainNav from '@/components/layouts/MainNav.vue'
import HeaderLayout from '@/components/layouts/HeaderLayout'

export default {
	components: {
		MainNav,
		HeaderLayout
	}
}
</script>

<style lang="scss" scoped>
	.home-container {
		width: 100%;
		height: 100%;
		background-color: #F5F6FA;
		display: flex;
		flex-direction: column;


		.main-section {
			flex: 1 1 auto;
			width: 100%;
			overflow: auto;
			position: relative;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;

			h2 {
				text-transform: capitalize;
				width: 100%;
				margin-top: 20px;
				padding: 0;
			}

			.view-container {
				flex: 1 1 auto;
				min-width: 1000px;
				min-height: 600px;
				width: 100%;
				position: relative;

				.router-view {
					padding: 20px 0;
					width: 100%;
					height: 100%;
					display: flex;
					flex-direction: column;
					top: 0;
				}
			}

		}
	}
</style>
